import { Flex } from '@chakra-ui/react';
import React from 'react';

import { Timestamp } from '~/packages/common-frontend/components/Timestamp';
import { Typography } from '~/packages/common-frontend/components/Typography';

// Exports
type EventFeedItemProps = {
  leftSlot?: React.ReactNode;
  children: React.ReactNode;
  createdAt: React.ComponentProps<typeof Timestamp>['timestamp'];
};
export const EventFeedItem = ({
  leftSlot,
  children,
  createdAt,
}: EventFeedItemProps) => {
  return (
    <Flex alignItems="flex-start" gap="0.5rem">
      {leftSlot}
      <Typography inline variant="detail-muted">
        {children} <Timestamp variant="timeago" timestamp={createdAt} showDot />
      </Typography>
    </Flex>
  );
};
